import { Currency } from '@/core/currency/interfaces';

const PYG: Currency = {
    name: 'Paraguayan Guaraní',
    demonym: 'Paraguayan',
    majorSingle: 'Guaraní',
    majorPlural: 'Guaraníes',
    codeNumeric: '600',
    symbol: '₲',
    symbolNative: '₲',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'PYG',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default PYG;
